// extracted by mini-css-extract-plugin
module.exports = {"app":"Main_app__2TkeV","header":"Main_header__EfdLG","main":"Main_main__197uu"};